"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFrequencyMessage = void 0;

var _consts = require("../consts");

var _IntervalFrequencyError = _interopRequireDefault(require("../errors/IntervalFrequencyError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var EVERY = 'every';
var PER = 'per';
var NUMBER_STR = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
var NUMBER_TIMES_STR = ['once', 'twice'].concat(_toConsumableArray(NUMBER_STR.slice(2).map(function (numberStr) {
  return "".concat(numberStr, " times");
})));
var ALL_DAYS = Object.keys(_consts.DayOfWeek).reduce(function (acc, dayOfWeek, i) {
  var day = _consts.DayOfWeek[parseInt(dayOfWeek, 10)];

  acc[day] = {
    pos: i,
    label: _consts.FullDays[day]
  };
  return acc;
}, {});
var ALL_SHORT_DAYS = Object.keys(_consts.DayOfWeek).reduce(function (acc, dayOfWeek, i) {
  var day = _consts.DayOfWeek[parseInt(dayOfWeek, 10)];

  acc[day] = {
    pos: i,
    label: _consts.ShortDays[day]
  };
  return acc;
}, {});

var CustomFrequencyMessage = /*#__PURE__*/function () {
  function CustomFrequencyMessage(frequency, customFrequency) {
    _classCallCheck(this, CustomFrequencyMessage);

    this.frequency = frequency;
    this.customFrequency = customFrequency;

    _defineProperty(this, "messageArray", []);
  }
  /**
   *
   * @param options For backwards compatibility, messageStart defaults to "This inspection will be required".
   * @returns User friendly string describing the custom frequency
   */


  _createClass(CustomFrequencyMessage, [{
    key: "getMessage",
    value: function getMessage() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$messageStart = _ref.messageStart,
          messageStart = _ref$messageStart === void 0 ? 'This inspection will be required' : _ref$messageStart,
          _ref$omitPeriodPunctu = _ref.omitPeriodPunctuation,
          omitPeriodPunctuation = _ref$omitPeriodPunctu === void 0 ? false : _ref$omitPeriodPunctu;

      if (!this.customFrequency) {
        return '';
      }

      this.buildMessage(this.customFrequency, messageStart);
      var message = this.messageArray.join(' '); // the generated portion of the message is in lowercase - if messageStart isn't passed in, capitalize the first
      //  letter of the string we're returning

      var formattedMessage = "".concat(messageStart === '' ? message.charAt(0).toUpperCase() + message.slice(1) : message).concat(omitPeriodPunctuation ? '' : '.');
      return formattedMessage;
    }
  }, {
    key: "getShortMessage",
    value: function getShortMessage() {
      if (!this.customFrequency) {
        return '';
      }

      this.buildShortMessage(this.customFrequency);
      return "(".concat(this.messageArray.join(' '), ")");
    }
  }, {
    key: "pushMessage",
    value: function pushMessage(message) {
      if (message) this.messageArray.push(message);
    }
  }, {
    key: "buildMessage",
    value: function buildMessage(customFrequency, messageStart) {
      var numberOfEvents = customFrequency.numberOfEvents,
          every = customFrequency.every;
      this.messageArray = [];
      this.pushMessage(messageStart);
      var repeatSequence = this.getRepeatSequence(customFrequency);

      if (numberOfEvents > 1 || this.frequency === _consts.IntervalFrequencyEnum.DAY && numberOfEvents === 1 && every > 1) {
        this.pushMessage(this.getNumToStr(numberOfEvents, true));
      }

      if (this.frequency === _consts.IntervalFrequencyEnum.MONTH && repeatSequence) {
        this.pushMessage(EVERY);
        this.pushMessage(repeatSequence.sequence);
        return;
      }

      if (every > 1) {
        this.pushMessage(EVERY);
        this.pushMessage(this.getNumToStr(every));
      }

      this.pushMessage(this.getPreFrequencyName(customFrequency));
      this.pushMessage(this.getFrequencyName(customFrequency));

      if (repeatSequence) {
        this.messageArray[this.messageArray.length - 1] += ',';

        if (repeatSequence.count === 1) {
          this.pushMessage(EVERY);
        }

        this.pushMessage(repeatSequence.sequence);
      }
    }
  }, {
    key: "buildShortMessage",
    value: function buildShortMessage(customFrequency) {
      var numberOfEvents = customFrequency.numberOfEvents,
          every = customFrequency.every;
      this.messageArray = [this.getNumber(numberOfEvents, true)];
      var repeatSequence = this.getRepeatSequence(customFrequency, true);

      if (repeatSequence) {
        this.pushMessage(EVERY);
        this.pushMessage(repeatSequence.sequence);
        return;
      }

      if (every === 1) {
        this.pushMessage(PER);
      } else {
        this.pushMessage(EVERY);
        this.pushMessage(this.getNumber(every));
      }

      this.pushMessage(this.getFrequencyName(customFrequency, true));
    }
  }, {
    key: "getNumToStr",
    value: function getNumToStr(num, appendTimes) {
      var numberStrings1To10 = appendTimes ? NUMBER_TIMES_STR : NUMBER_STR;
      var numStr = num > 0 && num < 11 ? numberStrings1To10[num - 1] : "".concat(num.toString()).concat(appendTimes ? ' times' : '');
      return numStr;
    }
  }, {
    key: "getNumber",
    value: function getNumber(num, appendTimes) {
      var numStr = num.toString();
      return appendTimes ? "".concat(numStr, " time").concat(num > 1 ? 's' : '') : numStr;
    }
  }, {
    key: "getPreFrequencyName",
    value: function getPreFrequencyName(customFrequency) {
      var numberOfEvents = customFrequency.numberOfEvents,
          every = customFrequency.every;

      switch (this.frequency) {
        case _consts.IntervalFrequencyEnum.DAY:
          if (numberOfEvents > 2 && every === 1) {
            return PER;
          }

          break;

        case _consts.IntervalFrequencyEnum.WEEK:
        case _consts.IntervalFrequencyEnum.MONTH:
        case _consts.IntervalFrequencyEnum.YEAR:
          if (every === 1) {
            return EVERY;
          }

          break;

        default:
          throw new _IntervalFrequencyError["default"]("frequency not supported: ".concat(this.frequency));
      }

      return null;
    }
  }, {
    key: "getFrequencyName",
    value: function getFrequencyName(customFrequency, _short) {
      var numberOfEvents = customFrequency.numberOfEvents,
          every = customFrequency.every;

      switch (this.frequency) {
        case _consts.IntervalFrequencyEnum.DAY:
          if (_short) {
            return every === 1 ? 'day' : 'days';
          }

          if (numberOfEvents > 2 && every === 1) {
            return 'day';
          }

          return every === 1 ? 'daily' : 'days';

        case _consts.IntervalFrequencyEnum.WEEK:
          return every === 1 ? 'week' : 'weeks';

        case _consts.IntervalFrequencyEnum.MONTH:
          return every === 1 ? 'month' : 'months';

        case _consts.IntervalFrequencyEnum.YEAR:
          return every === 1 ? 'year' : 'years';

        default:
          throw new _IntervalFrequencyError["default"]("frequency not supported: ".concat(this.frequency));
      }
    }
  }, {
    key: "getRepeatSequence",
    value: function getRepeatSequence(customFrequency, _short2) {
      var every = customFrequency.every,
          repeatOn = customFrequency.repeatOn;

      switch (this.frequency) {
        case _consts.IntervalFrequencyEnum.DAY:
          if (every === 1) {
            var selectedDays = repeatOn || [];
            var allOptions = _short2 ? ALL_SHORT_DAYS : ALL_DAYS;

            if (selectedDays.length === Object.keys(allOptions).length) {
              return null;
            }

            return this.getSequence(selectedDays, allOptions, true, _short2);
          }

          break;

        case _consts.IntervalFrequencyEnum.MONTH:
          if ([1, 2, 3, 4, 6].some(function (val) {
            return val === every;
          })) {
            return this.getSequence(repeatOn || [], this.getAllMonths(customFrequency, _short2), false, _short2);
          }

          break;

        case _consts.IntervalFrequencyEnum.WEEK:
        case _consts.IntervalFrequencyEnum.YEAR:
          return null;

        default:
          throw new _IntervalFrequencyError["default"]("frequency not supported: ".concat(this.frequency));
      }

      return null;
    }
  }, {
    key: "getAllMonths",
    value: function getAllMonths(customFrequency, _short3) {
      var every = customFrequency.every,
          startMonth = customFrequency.startMonth;
      var months = Object.values(_consts.Months);

      if (every === 1) {
        return months.reduce(function (acc, month, i) {
          acc[month] = {
            pos: i,
            label: _short3 ? _consts.ShortMonths[month] : _consts.FullMonths[month]
          };
          return acc;
        }, {});
      }

      if (startMonth != null) {
        var offset = startMonth % every;
        months = months.slice(offset).concat(months.slice(0, offset));
      }

      var pos = 0;
      var last;
      return months.reduce(function (acc, month, i) {
        var mod = i % every;

        if (mod === 0) {
          last = {
            pos: pos,
            label: _consts.ShortMonths[month]
          };
          acc[month] = last;
          pos += 1;
        } else if (mod === every - 1) {
          last.label = "".concat(last.label, "-").concat(_consts.ShortMonths[month]);
        }

        return acc;
      }, {});
    }
  }, {
    key: "getSequence",
    value: function getSequence(list, all, checkForGaps, _short4) {
      if (!list.length) {
        return null;
      }

      var sorted = list.reduce(function (acc, item) {
        var sequenceValue = all[item];

        if (!sequenceValue) {
          return acc;
        }

        var result = [].concat(_toConsumableArray(acc), [sequenceValue]);
        return result;
      }, []).sort(function (a, b) {
        return a.pos - b.pos;
      });
      var firstValue = sorted[0];
      if (!firstValue) return null;
      var value = {
        count: sorted.length,
        sequence: ''
      };

      if (sorted.length === 1) {
        value.sequence = firstValue.label;
        return value;
      }

      var lastValue = sorted[sorted.length - 1];
      if (!lastValue) return null;

      if (checkForGaps && this.hasNoGaps(sorted)) {
        value.sequence = _short4 ? "".concat(firstValue.label, "-").concat(lastValue.label) : "".concat(firstValue.label, " - ").concat(lastValue.label);
        return value;
      }

      if (_short4 && checkForGaps) {
        value.sequence = this.buildSequenceWithSubGaps(sorted);
        return value;
      }

      var labels = sorted.map(function (s) {
        return s.label;
      });
      value.sequence = "".concat(labels.slice(0, labels.length - 1).join(', '), ", and ").concat(labels[labels.length - 1]);
      return value;
    }
  }, {
    key: "hasNoGaps",
    value: function hasNoGaps(list) {
      var prev = list[0];

      for (var i = 1; i < list.length; i += 1) {
        var current = list[i];
        if (!prev || !current) return false;

        if (prev.pos + 1 !== current.pos) {
          return false;
        }

        prev = current;
      }

      return true;
    }
  }, {
    key: "buildSequenceWithSubGaps",
    value: function buildSequenceWithSubGaps(list) {
      var first = list[0];
      if (!first) return '';
      var prev = first;
      var sequence = [first.label];

      var addPrev = function addPrev() {
        var diff = prev.pos - first.pos;

        if (diff === 1) {
          sequence.push(prev.label);
        } else if (diff > 1) {
          sequence[sequence.length - 1] += "-".concat(prev.label);
        }
      };

      for (var i = 1; i < list.length; i += 1) {
        if (prev.pos + 1 !== list[i].pos) {
          addPrev();
          first = list[i];
          sequence.push(first.label);
        }

        prev = list[i];
      }

      if (sequence[sequence.length - 1] === first.label) {
        addPrev();
      }

      if (sequence.length === 1) {
        // just checked the length, so we know sequence[0] is defined
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return sequence[0];
      }

      var last = sequence.length - 1;
      return "".concat(sequence.slice(0, last).join(', '), ", and ").concat(sequence[last]);
    }
  }]);

  return CustomFrequencyMessage;
}();

exports.CustomFrequencyMessage = CustomFrequencyMessage;